export default __webpack_public_path__ + "0e63f49a4d6ab3e1ea75be5fe48e1039.png";